// extracted by mini-css-extract-plugin
export var infoSection = "_k-1";
export var infoSectionContainer = "_k-0";
export var infoSectionTitleRow = "_k-2";
export var multiLineInfo = "_k-4";
export var strong = "_k-3";